"use strict";
// Copyright (c) StrangeBee 2023
Object.defineProperty(exports, "__esModule", { value: true });
exports.httpMethods = exports.notifiersAvailable = exports.notificationTriggerValues = exports.webhookTypeAvailable = exports.notifierToWebhookType = void 0;
exports.notifierToWebhookType = {
    Webhook: 'webhook',
    Mattermost: 'mattermost',
    Slack: 'slack',
    Teams: 'teams',
    HttpRequest: 'http',
};
exports.webhookTypeAvailable = ['webhook', 'mattermost', 'slack', 'teams', 'http'];
exports.notificationTriggerValues = [
    'ObservableCreated',
    'CaseObservableCreated',
    'AlertObservableCreated',
    'CaseCreated',
    'CaseClosed',
    'AlertCreated',
    'AlertAssigned',
    'AnyEvent',
    'CaseShared',
    'JobFinished',
    'LogInMyTask',
    'TaskAssigned',
    'FilteredEvent',
    'AlertImported',
    'TaskClosed',
    'TaskMandatory',
];
exports.notifiersAvailable = [
    'Webhook',
    'HttpRequest',
    'EmailerToUser',
    'EmailerToAddr',
    'RunAnalyzer',
    'RunResponder',
    'Mattermost',
    'Kafka',
    'Redis',
    'Slack',
    'Teams',
];
exports.httpMethods = ['GET', 'PUT', 'POST', 'PATCH', 'DELETE', 'HEAD'];
